module.exports = __webpack_public_path__ + "media/images/plan-grid1-0dd8de990df8d67a66d9f69414d5ea70.jpg";